import {
  GET_AREA_LIST_FAIL,
  GET_AREA_LIST_REQUEST,
  GET_AREA_LIST_SUCCESS,
  GET_COUNTRY_LIST_FAIL,
  GET_COUNTRY_LIST_REQUEST,
  GET_COUNTRY_LIST_SUCCESS,
} from "src/constants/types";

export const areaReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_COUNTRY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_COUNTRY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        countries: actions.payload,
        error: "",
      };

    case GET_COUNTRY_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_AREA_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_AREA_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        areas: actions.payload,
        error: "",
      };

    case GET_AREA_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
